import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconListSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconListSparkle"><Path d="M3 5V7H21V5H3Z" fill="currentColor"/><Path d="M17 8.26393L14.7546 12.7546L10.2639 15L14.7546 17.2454L17 21.7361L19.2454 17.2454L23.7361 15L19.2454 12.7546L17 8.26393Z" fill="currentColor"/><Path d="M3 11V13H10V11H3Z" fill="currentColor"/><Path d="M3 17V19H8V17H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconListSparkle;
